import { FileDown, HandCoins } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatAUD } from "@/lib/format";
import { headline } from "@/components/settlement/headline";

const Line = ({ label, value, testId, strong, negate }) => (
  <div className={`flex justify-between py-1.5 text-sm ${strong ? "border-t border-border mt-1 pt-2.5 font-semibold" : ""}`}>
    <span className={strong ? "" : "text-muted-foreground"}>{label}</span>
    <span className="font-mono" data-testid={testId}>{formatAUD(negate && Number(value) !== 0 ? `-${value}` : value)}</span>
  </div>
);

export default function DirectorCard({ d, onPdf, onRecord }) {
  const h = headline(d.result);
  const slug = d.name.toLowerCase();
  return (
    <div className="border border-border bg-card p-6 flex flex-col" data-testid={`settlement-card-${slug}`}>
      <div className="flex items-baseline justify-between">
        <h3 className="font-display text-2xl font-semibold tracking-tight">{d.name}</h3>
        <span className="font-mono text-xs text-muted-foreground">{d.share_pct}%</span>
      </div>
      <div className={`font-display text-xl mt-3 leading-snug ${h.tone}`} data-testid={`settlement-headline-${slug}`}>{h.text}</div>
      <div className="mt-5">
        <Line label="Equal share" value={d.equal_share} testId={`settlement-equal-share-${slug}`} />
        <Line label="Adjustment" value={d.adjustment} testId={`settlement-adjustment-${slug}`} />
        <Line label="Total personal income" value={d.personal_income} testId={`settlement-personal-income-${slug}`} />
        <Line label="Credits" value={d.credits} testId={`settlement-credits-${slug}`} />
        <Line label="Debits" value={d.debits} negate testId={`settlement-debits-${slug}`} />
        {d.extras.map((x, i) => <Line key={i} label={`Included: ${x.label}`} value={x.amount} testId={`settlement-extra-${slug}-${i}`} />)}
        <Line label="Result" value={d.result} strong testId={`settlement-result-${slug}`} />
      </div>
      <div className="mt-auto pt-6 flex flex-wrap gap-2">
        <Button variant="outline" size="sm" onClick={onPdf} data-testid={`settlement-pdf-${slug}`}><FileDown className="h-4 w-4 mr-1" /> PDF statement</Button>
        <Button size="sm" onClick={onRecord} disabled={h.text === "Settled"} data-testid={`settlement-record-${slug}`}><HandCoins className="h-4 w-4 mr-1" /> Record settlement</Button>
      </div>
    </div>
  );
}
